export const checkinModalConversation = {
  guestFallback: "Hóspede",
  conversationLabel: "Conversa:",
  replyOnWhatsAppLabel: "Responder no WhatsApp:",
  replyOnWhatsAppTooltip: "Responder no WhatsApp",
};
